export const PERSONS_ON_DELETE_REQUESTED = 'PERSONS_ON_DELETE_REQUESTED';
export const PERSONS_ON_DELETE_SUCCEEDED = 'PERSONS_ON_DELETE_SUCCEEDED';
export const PERSONS_ON_DELETE_FAILED = 'PERSONS_ON_DELETE_FAILED';

export const PERSONS_ON_GET_ALL_REQUESTED = 'PERSONS_ON_GET_ALL_REQUESTED';
export const PERSONS_ON_GET_ALL_SUCCEEDED = 'PERSONS_ON_GET_ALL_SUCCEEDED';
export const PERSONS_ON_GET_ALL_FAILED = 'PERSONS_ON_GET_ALL_FAILED';

export const PERSONS_ON_GET_FORM_REQUESTED = 'PERSONS_ON_GET_FORM_REQUESTED';
export const PERSONS_ON_GET_FORM_SUCCEEDED = 'PERSONS_ON_GET_FORM_SUCCEEDED';
export const PERSONS_ON_GET_FORM_FAILED = 'PERSONS_ON_GET_FORM_FAILED';

export const PERSONS_ON_GET_ONE_REQUESTED = 'PERSONS_ON_GET_ONE_REQUESTED';
export const PERSONS_ON_GET_ONE_SUCCEEDED = 'PERSONS_ON_GET_ONE_SUCCEEDED';
export const PERSONS_ON_GET_ONE_FAILED = 'PERSONS_ON_GET_ONE_FAILED';

export const PERSONS_ON_SAVE_REQUESTED = 'PERSONS_ON_SAVE_REQUESTED';
export const PERSONS_ON_SAVE_SUCCEEDED = 'PERSONS_ON_SAVE_SUCCEEDED';
export const PERSONS_ON_SAVE_FAILED = 'PERSONS_ON_SAVE_FAILED';
